<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end gap-3">
    <div class="flex-grow-1">
      <ds-search-bar
        class="w-100"
        [fullKeyword]="'search_by_name_or_email' | translate"
        [allowEmptySearch]="true"
        (search)="handleSearch($event)"
      ></ds-search-bar>
    </div>
    <div class="d-flex gap-2 flex-wrap justify-content-start justify-content-lg-end align-self-stretch align-self-lg-auto">
      @if (showExportButton$ | async) {
        <app-export-report-button
          (onDownloadReport)="onDownloadReport($event)"
          [fileExtensions]="[FileExtension.xlsx]"
          [dropdownButtonLabel]="'export_users'"
        >
        </app-export-report-button>
      }
      <button
        ds-button
        type="button"
        data-test-id="add-user-button"
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.Plus"
        (click)="onAddUsers()"
      >
        {{ 'label_add_user' | translate }}
      </button>
    </div>
  </div>

  <div class="mt-3">
    <app-ngb-table [config]="tableConfig" [data]="(tableRows$ | async) ?? []"></app-ngb-table>
  </div>

  <div class="pagination-entries mb-0 justify-content-end">
    <ds-pagination
      [ariaLabel]="'digital_property_users_table_pagination' | translate"
      [page]="page$ | async"
      [pageSize]="PAGE_SIZE"
      [collectionSize]="totalRows$"
      (pageChange)="onPageChange($event)"
    ></ds-pagination>
  </div>
</div>
